import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../utils/api";
import styles from "./ViewRolePage.module.scss";
import { AxiosResponse, AxiosErrorType } from "../../../src/types";

interface UserType {
  id: number;
  name: string;
  permissions: Record<string, boolean>;
  issuperadmin: boolean;
}

const ViewUserTypePage: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [userType, setUserType] = useState<UserType | null>(null);
  const [error, setError] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.post<AxiosResponse<{ usertypes: UserType[] }>>("/core/role/usertype/get", {});
        const userTypeData = response.data.usertypes?.find((ut) => ut.id === parseInt(id || "0"));
        if (!userTypeData) {
          throw new Error("User type not found");
        }
        setUserType(userTypeData);
      } catch (err: any) {
        setError(err.response?.data?.message || "Failed to fetch user type");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error || !userType) {
    return <div className={styles.error}>{error || "User type not found"}</div>;
  }

  return (
    <div className={styles.container}>
      <h2>View User Type</h2>
      <div className={styles.formGroup}>
        <label>User Type Name</label>
        <p>{userType.name}</p>
      </div>
      <div className={styles.formGroup}>
        <label>Superadmin</label>
        <p>{userType.issuperadmin ? "Yes" : "No"}</p>
      </div>
      <div className={styles.formGroup}>
        <label>Permissions</label>
        <p>{JSON.stringify(userType.permissions)}</p>
      </div>
      <button onClick={() => navigate("/roles")}>Back to Roles</button>
    </div>
  );
};

export default ViewUserTypePage;
